<template>
  <div class="sign-warp">
    <div id="sign"></div>
  </div>
</template>

<script>

import ImageEditor from "tui-image-editor";

export default {
  name: "Sign",
  props: {
    bgUrl:''
  },
  data() {
    return {
      instance: null,
      tuiBg:require('../assets/img/base/transparent.png')
    }

  },
  mounted() {
    this.initTui()
  },
  methods:{
    initTui(){
      const localeZh = {
        Crop: '裁剪',
        ZoomIn: '放大',
        ZoomOut: '缩小',
        Hand: '拖拽',
        History: '历史记录',
        DeleteAll: '全部删除',
        Delete: '删除',
        Undo: '撤销',
        Redo: '反撤销',
        Reset: '重置',
        Flip: '镜像',
        Rotate: '旋转',
        Draw: '画',
        Shape: '形状标注',
        Icon: '图标标注',
        Text: '文字标注',
        Mask: '遮罩',
        Filter: '滤镜',
        Bold: '加粗',
        Italic: '斜体',
        Underline: '下划线',
        Left: '左对齐',
        Center: '居中',
        Right: '右对齐',
        Color: '颜色',
        'Text size': '字体大小',
        Custom: '自定义',
        Square: '正方形',
        Apply: '应用',
        Cancel: '取消',
        'Flip X': 'X 轴',
        'Flip Y': 'Y 轴',
        Range: '区间',
        Stroke: '描边',
        Fill: '填充',
        Circle: '圆',
        Triangle: '三角',
        Rectangle: '矩形',
        Free: '曲线',
        Straight: '直线',
        Arrow: '箭头',
        'Arrow-2': '箭头2',
        'Arrow-3': '箭头3',
        'Star-1': '星星1',
        'Star-2': '星星2',
        Polygon: '多边形',
        Location: '定位',
        Heart: '心形',
        Bubble: '气泡',
        'Custom icon': '自定义图标',
        'Load Mask Image': '加载蒙层图片',
        Grayscale: '灰度',
        Blur: '模糊',
        Sharpen: '锐化',
        Emboss: '浮雕',
        'Remove White': '除去白色',
        Distance: '距离',
        Brightness: '亮度',
        Noise: '噪音',
        'Color Filter': '彩色滤镜',
        Sepia: '棕色',
        Sepia2: '棕色2',
        Invert: '负片',
        Pixelate: '像素化',
        Threshold: '阈值',
        Tint: '色调',
        Multiply: '正片叠底',
        Blend: '混合色'
      }
      const customTheme = {
        // image 左上角度图片
        'common.bi.image': '', // 在这里换上你喜欢的logo图片
        'common.bisize.width': '0px',
        'common.bisize.height': '0px',
        'common.backgroundImage': 'none',
        'common.backgroundColor': 'transparent',
        // 'common.border': '1px solid #444',
        // header
        'header.backgroundImage': 'none',
        'header.backgroundColor': '#f3f4f6',
        'header.border': '0px',
        'header.display': 'none',
        'loadButton.display': 'none', // 可以直接隐藏掉
        // download button
        'downloadButton.display': 'none', // 可以直接隐藏掉
        // icons default
        'menu.normalIcon.color': '#8a8a8a',
        'menu.activeIcon.color': '#555555',
        'menu.disabledIcon.color': '#434343',
        'menu.hoverIcon.color': '#e9e9e9',
        'submenu.normalIcon.color': '#8a8a8a',
        'submenu.activeIcon.color': '#e9e9e9',
        'menu.iconSize.width': '24px',
        'menu.iconSize.height': '24px',
        'submenu.iconSize.width': '32px',
        'submenu.iconSize.height': '32px',

        // submenu primary color
        // 'submenu.backgroundColor': '#1e1e1e',//选择操作
        'submenu.partition.color': '#858585',

        // submenu labels
        'submenu.normalLabel.color': '#858585',
        'submenu.normalLabel.fontWeight': 'lighter',
        'submenu.activeLabel.color': '#fff',
        'submenu.activeLabel.fontWeight': 'lighter',

        // checkbox style
        'checkbox.border': '1px solid #ccc',
        'checkbox.backgroundColor': '#fff',

        // rango style
        'range.pointer.color': '#fff',
        'range.bar.color': '#666',
        'range.subbar.color': '#d1d1d1',

        'range.disabledPointer.color': '#414141',
        'range.disabledBar.color': '#282828',
        'range.disabledSubbar.color': '#414141',

        'range.value.color': '#fff',
        'range.value.fontWeight': 'lighter',
        'range.value.fontSize': '11px',
        'range.value.border': '1px solid #353535',
        'range.value.backgroundColor': '#151515',
        'range.title.color': '#fff',
        'range.title.fontWeight': 'lighter',

        // colorpicker style
        'colorpicker.button.border': '1px solid #1e1e1e',
        'colorpicker.title.color': '#fff'
      }
      const ImageEditor = require('tui-image-editor')
      this.instance = new ImageEditor(
          document.querySelector('#sign'),
          {
            includeUI: { // 表示使用它内置的 UI 控件
              loadImage: {
                // path: this.bgUrl,// 照片路径
                path: this.tuiBg,// 照片路径
                name: 'test' //图片名称
              }, // 默认加载的图片
              initMenu: 'draw', // 表示编辑器加载后，第一个被选中的操作菜单功能
              menu: [
                'draw', // 添加绘画
                'shape', // 添加形状
                'icon', // 添加图标
                'text', // 添加文本
                'mask', // 添加覆盖
              ], // 支持的菜单
              locale: localeZh, // 国际化对照字段
              theme: customTheme,// 自定义的主题配置
              usageStatistics: false,
              menuBarPosition: 'right'
            },
            cssMaxWidth: 900, // 编辑器 Canvas 的最大宽度
            cssMaxHeight: 1300, // 编辑器 Canvas 的最大高度
            selectionStyle: {
              cornerSize: 20,
              rotatingPointOffset: 70
            }
          })

      document.getElementsByClassName('tui-image-editor-main')[0].style.top = 0
    },
    saveImg(){
      console.log(this.instance.toDataURL())
    }
  }
}
</script>

<style scoped src="../assets/css/sign.css">

</style>
<style>
/*.sign-warp .tui-image-editor-submenu{*/
/*  display: table !important;*/
/*}*/
/*.sign-warp .tui-image-editor{*/
/*  left: 107px !important;*/
/*}*/
/*.sign-warp .tui-image-editor-container.left .tui-image-editor-submenu{*/
/*  width: 186px !important;*/
/*  backdrop-filter: blur(10px);*/
/*}*/
/*.sign-warp .tui-image-editor-container .tui-image-editor-help-menu {*/
/*  background-color: rgba(255,255,255,.6);*/
/*}*/
</style>
